import type { SearchCriteria, Selection } from '@/entities/searchCriteria';

function getDestinationKey(destination: Selection | null): (string | number)[] | null {
  if (!destination || destination.kind === 'none') return null;

  const { kind, country } = destination;

  if (kind === 'resorts') return [kind, country.id, ...destination.resorts.map(({ id }) => id)];

  if (kind === 'hotels') return [kind, country.id, ...destination.hotels.map(({ id }) => id)];

  return [kind, country.id];
}

export function getSerpHitKey({ fromCity, destination, dateRange, nights, tourists }: SearchCriteria): string {
  return JSON.stringify([
    fromCity?.id ?? null,
    getDestinationKey(destination),
    dateRange && [dateRange.from, dateRange.to, dateRange.daysFlexible ?? 0],
    nights && [nights.from, nights.to],
    tourists?.rooms.map(({ adults, childrenAges }) => [adults, childrenAges]) ?? null,
  ]);
}
